export default "__VITE_ASSET__B8k92TyG__"